import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef } from "vue"
import _imports_0 from '../../assets/img/dropselect2.png'
import _imports_1 from '../../assets/img/noImg.png'
import _imports_2 from '../../assets/zt_404.png'
import _imports_3 from '@/assets/img/tips／exclamation-circle-fill@2x.png'


const _hoisted_1 = { style: {"background-color":"#f5f5f5","margin-top":"0.7rem"} }
const _hoisted_2 = { class: "newTrialMaterial comBox" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { style: {"display":"flex","justify-content":"space-between","padding":"0.12rem 0.16rem","box-sizing":"border-box"} }
const _hoisted_6 = ["icon"]
const _hoisted_7 = { style: {"display":"flex","width":"100%"} }
const _hoisted_8 = { class: "el-dropdown-link" }
const _hoisted_9 = { style: {"display":"flex"} }
const _hoisted_10 = {
  style: {},
  class: "table_img"
}
const _hoisted_11 = { class: "table_information" }
const _hoisted_12 = { style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","color":"#333333","width":"100%"} }
const _hoisted_13 = {
  key: 0,
  class: "satatusLab",
  style: {"background":"#4bc18520","color":"#4bc185"}
}
const _hoisted_14 = {
  key: 1,
  class: "satatusLab",
  style: {"background":"#f53f3f20","color":"#f53f3f"}
}
const _hoisted_15 = { style: {"display":"flex"} }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  style: {"height":"550px"}
}
const _hoisted_19 = { style: {"text-align":"center","font-size":"0.16rem","margin":"0.16rem 0"} }
const _hoisted_20 = { style: {"display":"flex","justify-content":"center"} }

import leftTemplate1 from "@/components/leftTemplate1.vue";
import { ref } from "vue";
import type { TabsPaneContext } from "element-plus";
import { ElMessage, ElTable } from "element-plus";
import { Search } from "@element-plus/icons-vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { serverUrls } from "../../assets/js/ls_tgServerUrls.js";

import { useRouter } from "vue-router";
interface User {
  date: string;
  name: string;
  address: string;
  katype: string;
  pirce: string;
  number: number;
  number1: number;
  time: string;
  time1: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'onSaleMaterial',
  setup(__props) {

let pageDef = ref({
  pageNum: 1,
  pageSize: 5,
  total: 0,
});
const page = pageDef;
const keyWord = ref("");
const activeName = ref("first");
const top_type = ref("");
const isOnlin = ref("");
var list = ref([]); // 创建一个空数组
// 表格
const allCheckbox = ref(false);
const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
};
const handleSelectionChange = (val: User[]) => {
  multipleSelection.value = val;
  if (multipleSelection.value.length == list.value.length) {
    allCheckbox.value = true;
  } else if (multipleSelection.value.length == 0) {
    allCheckbox.value = false;
    // multipleTableRef.value!.clearSelection()
  } else {
    allCheckbox.value = false;
  }
  console.log(allCheckbox.value, "单选点击后全选状态");
  // 使用map方法提取id并组成新的数组
  idArray.value = multipleSelection.value.map((obj) => obj.id);
};
const selectAll = () => {
  allCheckbox.value = !allCheckbox.value;
  console.log(allCheckbox.value);
  if (allCheckbox.value) {
    list.value.forEach((item, index) => {
      console.log(multipleTableRef.value);
      multipleTableRef.value!.toggleRowSelection(item, true);
    });
  } else {
    list.value.forEach((item, index) => {
      console.log(multipleTableRef.value);
      multipleTableRef.value!.toggleRowSelection(item, false);
    });
  }
};
//列表请求
let memberId = JSON.parse(localStorage.getItem("userList")).memberId;
const init = () => {
  let paramsA = {};
  paramsA = {
    memberId: memberId,
    materialType: top_type.value,
    isOnline: isOnlin.value,
    pageNum: page.value.pageNum,
    pageSize: page.value.pageSize,
  };
  console.log(paramsA);
  Axios("get", "/fodder/manage/on-list", paramsA, false, function (res) {
    console.info(res);
    list.value = res.data.rows;
    console.info(list.value);
    page.value.total = res.data.total;
  });
};

init();

// 删除、批量删除

let title = ref("");
let dialogDelVisible = ref(false);
let idArray = ref([]);
const handleDel = (index, row, type) => {
  console.log(idArray.value);
  if (idArray.value.length == 0) {
    ElMessage({
      message: "请选择选择需要删除的素材",
      type: "warning",
    });
    return;
  }
  title.value =
    type == "del"
      ? "删除后则无法恢复，是否继续？"
      : "是否确认将所选全部在售素材？";
  if (type == "del") {
    if (row.id) {
      idArray.value = [row.id];
      dialogDelVisible.value = true;
    } else {
      list.value.splice(index, 1);
    }
  } else {
    dialogDelVisible.value = true;
  }
};
const delSubmit = () => {
  console.log("删除", idArray);
  Axios(
    "delete",
    `/fodder/manage/remove/` + idArray.value,
    {},
    false,
    (res) => {
      if (res.data.code == 200) {
        dialogDelVisible.value = false;
        init();
        ElMessage({
          message: "删除成功",
          type: "success",
        });
      } else {
        ElMessage({
          message: "删除错误",
          type: "error",
        });
      }
    }
  );
};
//直接跳转
const router = useRouter();
const handlePerfect = (row) => {
  // IMAGE, MUSIC, VIDEO
  if (row.materialType == "VIDEO") {
    router.push({
      path: "/materiaPerfect",
      query: {
        id: row.id,
      },
    });
  } else if (row.materialType == "MUSIC") {
    router.push({
      path: "/musicPerfect",
      query: {
        id: row.id,
      },
    });
  } else if (row.materialType == "IMAGE") {
    router.push({
      path: "/picturePerfect",
      query: {
        id: row.id,
      },
    });
  }
};
//全部素材选择

const dropdownClick = (command: string | number | object) => {
  console.log(command, "-----------------");
  top_type.value = command;
  init();
  // IMAGE, MUSIC, VIDEO
};

const dropdownIsOnlinClick = (command: string | number | object) => {
  console.log(command, "-----------------");
  isOnlin.value = command;
  init();
};
/**
 * 分页
 * sizeChange
 * currentChange
 * prevClick
 * nextClick
 *
 */
const sizeChange = (val: number) => {
  console.log(val);
  init();
};
const currentChange = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const prevClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const nextClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};

//搜索事件
const keywordsearch = () => { };

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(leftTemplate1, { left_tabShow: 'on_sale_material' })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("div", null, null, -1)),
          _createElementVNode("div", {
            icon: _unref(Search),
            style: {"cursor":"pointer"},
            class: "topBtn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleDel('', '', 'delAll')))
          }, " 批量删除 ", 8, _hoisted_6)
        ]),
        _createVNode(_unref(ElTable), {
          ref_key: "multipleTableRef",
          ref: multipleTableRef,
          data: _unref(list),
          style: {"width":"100%"},
          onSelectionChange: handleSelectionChange,
          height: "650",
          width: "100%"
        }, {
          empty: _withCtx(() => [
            (_unref(list).length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[15] || (_cache[15] = [
                  _createElementVNode("div", { style: {"width":"90%","margin":"0 auto"} }, [
                    _createElementVNode("img", {
                      style: {"width":"100%","margin":"0 auto"},
                      src: _imports_2
                    })
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "55"
            }),
            _createVNode(_component_el_table_column, {
              property: "name",
              "min-width": "140",
              label: "商品信息",
              align: "center"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_dropdown, { onCommand: dropdownClick }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, { command: "" }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode("全部素材模板")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, { command: "VIDEO" }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                              _createTextVNode("视频")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, { command: "MUSIC" }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createTextVNode("音乐")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, { command: "IMAGE" }, {
                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                              _createTextVNode("图片")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_8, [
                        _createTextVNode(_toDisplayString(top_type.value == "MUSIC"
                      ? "音乐"
                      : top_type.value == "VIDEO"
                        ? "视频"
                        : top_type.value == "IMAGE"
                          ? "图片"
                          : "全部素材模板") + " ", 1),
                        _cache[6] || (_cache[6] = _createElementVNode("img", {
                          style: {"width":"14px","height":"14px"},
                          src: _imports_0
                        }, null, -1))
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_el_image, {
                      style: {"width":"100%","height":"100%"},
                      src: scope.row.showImage,
                      "zoom-rate": 1.2,
                      "preview-src-list": [scope.row.showImage],
                      "initial-index": 4,
                      fit: "cover"
                    }, {
                      error: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createElementVNode("div", {
                          class: "image-slot",
                          style: {"width":"100%","height":"100%"}
                        }, [
                          _createElementVNode("img", {
                            style: {"width":"100%","height":"100%"},
                            src: _imports_1
                          })
                        ], -1)
                      ])),
                      _: 2
                    }, 1032, ["src", "preview-src-list"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(scope.row.title ? scope.row.title : scope.row.name), 1)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              property: "payCount",
              width: "50",
              label: "购买",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              property: "selfPrice",
              width: "107",
              label: "个人授权售价",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              property: "createTime",
              width: "170",
              label: "创建时间",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              property: "updateTime",
              width: "170",
              label: "更新时间",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              property: "time1",
              width: "100",
              label: "上架/下架",
              align: "center"
            }, {
              header: _withCtx(() => [
                _createVNode(_component_el_dropdown, { onCommand: dropdownIsOnlinClick }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, { command: "0" }, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createTextVNode("上架")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, { command: "1" }, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode("下架")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "el-dropdown-link" }, [
                      _createTextVNode(" 上架/下架 "),
                      _createElementVNode("img", {
                        style: {"width":"14px","height":"14px"},
                        src: _imports_0
                      })
                    ], -1))
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx((scope) => [
                (scope.row.isOnline == 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "上架"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_14, "下架"))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "160",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", {
                    class: "topBtn",
                    style: {"cursor":"pointer"},
                    onClick: ($event: any) => (handlePerfect(scope.row))
                  }, " 修改信息 ", 8, _hoisted_16),
                  _createElementVNode("div", {
                    onClick: ($event: any) => (handleDel(scope.$index, scope.row, 'del')),
                    style: {"color":"#ff2929","margin-left":"0.1rem","line-height":"0.43rem","cursor":"pointer"}
                  }, " 删除 ", 8, _hoisted_17)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        (_unref(list).length != 0)
          ? (_openBlock(), _createBlock(_component_el_pagination, {
              key: 0,
              "current-page": _unref(page).pageNum,
              "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_unref(page).pageNum) = $event)),
              "page-size": _unref(page).pageSize,
              "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(page).pageSize) = $event)),
              onSizeChange: sizeChange,
              onCurrentChange: currentChange,
              style: {"margin":"0.4rem 0"},
              background: "",
              layout: "prev, pager, next",
              total: _unref(page).total
            }, null, 8, ["current-page", "page-size", "total"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: _unref(dialogDelVisible),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(dialogDelVisible) ? (dialogDelVisible).value = $event : dialogDelVisible = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[16] || (_cache[16] = _createElementVNode("div", { style: {"width":"0.4rem","height":"0.4rem","margin":"0 auto"} }, [
          _createElementVNode("img", {
            style: {"height":"100%"},
            src: _imports_3
          })
        ], -1)),
        _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(title)), 1),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(dialogDelVisible) //@ts-ignore
 ? dialogDelVisible.value = false : dialogDelVisible = false))
          }, "取消"),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: delSubmit
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})